exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width: 1024px) {\n    /* .menu-subnav {\n        display: flex;\n        flex-direction: row;\n    } */\n}", ""]);

